import { render } from "./SmartHome.vue?vue&type=template&id=ffc708e0"
import script from "./SmartHome.vue?vue&type=script&lang=js"
export * from "./SmartHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__